import { UrlService } from "src/app/shared/services/url/url.service";
import { AppConfigService } from "src/app/core/config/config.service";
import { UserLoginUri, CustomerUri } from "src/app/core/config/config.model";
import { environment } from "src/environments/environment";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class UserAuthActionsUriService {
  private userLoginUri: UserLoginUri;
  private baseUrl: string;
  private customerUri: CustomerUri;

  constructor(
    private urlService: UrlService,
    private apiConfig: AppConfigService
  ) {
    this.userLoginUri = apiConfig.appConfig.userLoginUri;
    this.customerUri = apiConfig.appConfig.customerUri;
    this.baseUrl = environment.baseUrl;
  }

  getLoginUserUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.userLoginUri.auth,
      this.userLoginUri.login
    );
  }

  getLoginUserStepOneUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.userLoginUri.auth,
      this.userLoginUri.login_step_one
    );
  }

  getLoginUserStepTwoUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.userLoginUri.auth,
      this.userLoginUri.login_step_one,
      this.userLoginUri.login_step_two
    );
  }

  getLoginUserStepThreeUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.userLoginUri.auth,
      this.userLoginUri.login_step_one,
      this.userLoginUri.login_step_three
    );
  }

  getRequestResetPasswordUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.account_recovery,
      this.customerUri.forget_password
    );
  }

  getVerifyResetTokenUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.account_recovery,
      this.customerUri.token_validation
    );
  }

  getResetPasswordUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.account_recovery,
      this.customerUri.reset_password
    );
  }

  getAddCustomerUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.my_customers,
      this.customerUri.public_register
    );
  }

  getSSOTokenUri() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.sso_auth
    );
  }

  getAcceptMerchantInvite() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      this.customerUri.accept_invite
    );
  }

  getAcceptNewMerchantInvite() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      this.customerUri.accept_new_invite
    );
  }

  getCheckInvitationCode() {
    return this.urlService.combineUri(
      this.baseUrl,
      this.customerUri.customers,
      this.customerUri.merchants,
      this.customerUri.check_code
    );
  }
}
